import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchCategoriesByMainCategory } from "../store/slices/categorySlice";
import { fetchMainCategories } from "../store/slices/mainCategorySlice";
import Header from "../components/layout/Header";
import { motion } from "framer-motion";
import { FaArrowRight } from "react-icons/fa";
import { FiArrowLeft } from "react-icons/fi";
import CategoryCard from "../components/common/CategoryCard";
import "../styles/MainCategorySelection.css";

const MainCategorySelection: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { mainCategories, loading: mainLoading } = useSelector(
    (state: any) => state.mainCategory,
  );
  const { hoveredCategories, loading: categoriesLoading } = useSelector(
    (state: any) => state.category,
  );

  useEffect(() => {
    if (id) {
      dispatch(fetchCategoriesByMainCategory(id) as any);
    }
    if (mainCategories.length === 0) {
      dispatch(fetchMainCategories() as any);
    }
    window.scrollTo(0, 0);
  }, [id, dispatch, mainCategories.length]);

  const currentCategories = id ? hoveredCategories[id] || [] : [];
  const currentMainCategory = mainCategories.find((mc: any) => mc._id === id);

  const handleCategoryClick = (categoryId: string) => {
    navigate(`/category/${categoryId}`);
  };

  return (
    <>
      <Header />
      <div className="category-selection-wrapper">
        <motion.div
          className="category-selection-header"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div className="category-selection-header-title-container">
            <button
              className="category-back-button"
              onClick={() => navigate(-1)}
              aria-label="Go Back"
            >
              <FiArrowLeft />
            </button>
            <h1 className="category-selection-title">
              {currentMainCategory?.name || "Explore Categories"}
            </h1>
          </div>
          <p className="category-selection-subtitle">
            Discover the best in{" "}
            {currentMainCategory?.name?.toLowerCase() || "this category"}
          </p>
        </motion.div>

        <div className="category-grid">
          {categoriesLoading
            ? Array(6)
                .fill(0)
                .map((_, i) => <div key={i} className="category-skeleton" />)
            : currentCategories.map((cat: any, index: number) => (
                <CategoryCard
                  key={cat._id}
                  id={cat._id}
                  name={cat.name}
                  description={cat.description}
                  image={cat.image}
                  index={index}
                  onClick={handleCategoryClick}
                />
              ))}
        </div>

        {!categoriesLoading && currentCategories.length === 0 && (
          <div style={{ textAlign: "center", padding: "100px 0" }}>
            <h2 style={{ color: "#64748b" }}>
              No categories found in this section.
            </h2>
            <button
              onClick={() => navigate("/")}
              style={{
                marginTop: "20px",
                padding: "12px 30px",
                backgroundColor: "#2874f0",
                color: "#fff",
                borderRadius: "12px",
                border: "none",
                fontWeight: "700",
                cursor: "pointer",
              }}
            >
              Return to Home
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default MainCategorySelection;
